import React, { useEffect, useRef, useState } from "react";
import UserInterface from "../../Components/InnerLayout/UserInterface";
import { useHistory, useParams } from "react-router-dom";
import Headerbar from "../../Components/InnerLayout/Headerbar";
const Productions = (params) => {
  const history = useHistory();
  return (
    <UserInterface>
      <div className="no-sidebar row" id="content">
        <Headerbar />

        <div className="inner-content row mx-0 finance-setting-chart chart-of-accounts">
          <div className="container px-0">
            <div className="row mx-0">
              <div class="shadowclass padding_cal">
                <div class="col-12">
                  <div class="calendr cel-product">
                    <a href="/productions/index/date:2022-05-15">
                      <i class="iconSprites arrow-left"></i>
                    </a>
                    <div class="text">
                      <span>16</span>
                      <small>
                        Monday
                        <br />
                        May&nbsp;2022
                      </small>
                    </div>
                    <a id="cal_open" href="#_">
                      <i class="iconSprites cal-icon"></i>
                    </a>
                  </div>
                </div>
              </div>
            </div>
            <div class="row mx-0">
              <div class="shadowclass">
                <div class="col-12">
                  <div class="counts">
                    <h4 class="event-alert">Daily Production Sheet</h4>
                    <div class="row justify-content-between align-items-center w-100 mx-0">
                      <div class="col-lg-4 col-md-5 px-0 mb-3 mb-sm-0">
                        <div class="search-box">
                          <form
                            action="/productions"
                            id="MenuItemIndexForm"
                            method="get"
                            accept-charset="utf-8"
                          >
                            {" "}
                            <input
                              name="keyword"
                              placeholder="Search"
                              type="text"
                              id="MenuItemKeyword"
                            />{" "}
                            <input type="submit" />
                          </form>
                        </div>{" "}
                      </div>
                      <div class="field invt-btns col-sm-7 col-12 align-right px-0">
                        <h6 class="">
                          <span class="status prod_status">
                            <span>Status:</span> Complete
                          </span>
                        </h6>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="row mt-3">
              <div className="accordion" id="accordionPanelsStayOpenExample">
                <div className="accordion-item">
                  <h2
                    className="accordion-header"
                    id="panelsStayOpen-headingOne"
                  >
                    <button
                      className="accordion-button"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#panelsStayOpen-collapseOne"
                      aria-expanded="true"
                      aria-controls="panelsStayOpen-collapseOne"
                    >
                      <div className="col d-flex align-items-center">
                        <h4 className="event-alert p-0 mb-0">Food</h4>
                      </div>{" "}
                    </button>
                  </h2>
                  <div
                    id="panelsStayOpen-collapseOne"
                    className="accordion-collapse collapse show"
                    aria-labelledby="panelsStayOpen-headingOne"
                  >
                    <div className="row mx-0">
                      <div className="container px-0">
                        <div className="shadowclass mt-0">
                          <div className="table-responsive">
                            <table className="checklist-table remove-space inventory_table">
                              <thead>
                                <tr>
                                  <th width="">Menu Item Name</th>
                                  <th className="text-right">
                                    Quantity Required
                                  </th>
                                  <th className="text-right">
                                    Prior Day Carryover
                                  </th>
                                  <th className="text-right">
                                    New Production
                                  </th>
                                  <th className="text-right">
                                    Total Available
                                  </th>
                                  <th className="text-right">Quantity Sold</th>
                                  <th className="text-right">Carry Over</th>
                                  <th class="text-right product-action"><a class="count-btn confirmAll" href="#">Confirm All</a></th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr class="data_tr">
                                  <td>Corona </td>
                                  <td className="align-right">
                                    Not Available{" "}
                                  </td>
                                  <td className="align-right">0 </td>
                                  <td className="align-right count-unit">
                                    <input
                                      name="data[MenuItem][0][new_production]"
                                      class="new_production"
                                      value="0"
                                      type="text"
                                      id="MenuItem0NewProduction"
                                    />{" "}
                                  </td>
                                  <td className="align-right">
                                    <span class="total_available_span">0</span>
                                  </td>
                                  <td className="align-right">0 </td>
                                  <td className="align-right">
                                    <span class="carry_over_span">0</span>{" "}
                                  </td>
                                  <td
                                    className="align-right"
                                    class="product-action"
                                  >
                                    <span class="spanConfirmation">
                                      <a
                                        class="count-btn confirmProd"
                                        href="#"
                                        val=""
                                      >
                                        Confirm
                                      </a>
                                    </span>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="accordion-item">
                  <h2
                    className="accordion-header"
                    id="panelsStayOpen-headingTwo2"
                  >
                    <button
                      className="accordion-button"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#panelsStayOpen-collapseTwo2"
                      aria-expanded="true"
                      aria-controls="panelsStayOpen-collapseTwo2"
                    >
                      <div className="col d-flex align-items-center">
                        <h4 className="event-alert p-0 mb-0">
                          Alcoholic Beverages
                        </h4>
                      </div>{" "}
                    </button>
                  </h2>
                  <div
                    id="panelsStayOpen-collapseTwo2"
                    className="accordion-collapse collapse show"
                    aria-labelledby="panelsStayOpen-headingTwo2"
                  >
                    <div className="row mx-0">
                      <div className="container px-0">
                        <div className="shadowclass mt-0">
                          <div className="table-responsive">
                            <table className="checklist-table remove-space">
                              <thead>
                                <tr>
                                  <th width="">Menu Item Name</th>
                                  <th className="align-right">
                                    Quantity Required
                                  </th>
                                  <th className="align-right">
                                    Prior Day Carryover
                                  </th>
                                  <th className="align-right">
                                    New Production
                                  </th>
                                  <th className="align-right">
                                    Total Available
                                  </th>
                                  <th className="align-right">Quantity Sold</th>
                                  <th className="align-right">Carry Over</th>
                                </tr>
                              </thead>
                            </table>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="accordion-item">
                  <h2
                    className="accordion-header"
                    id="panelsStayOpen-headingTwo3"
                  >
                    <button
                      className="accordion-button"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#panelsStayOpen-collapseTwo3"
                      aria-expanded="true"
                      aria-controls="panelsStayOpen-collapseTwo3"
                    >
                      <div className="col d-flex align-items-center">
                        <h4 className="event-alert p-0 mb-0">
                          Non-Alcoholic Beverages
                        </h4>
                      </div>{" "}
                    </button>
                  </h2>
                  <div
                    id="panelsStayOpen-collapseTwo3"
                    className="accordion-collapse collapse show"
                    aria-labelledby="panelsStayOpen-headingTwo3"
                  >
                    <div className="row mx-0">
                      <div className="container px-0">
                        <div className="shadowclass mt-0">
                          <div className="table-responsive">
                            <table className="checklist-table remove-space">
                              <thead>
                                <tr>
                                  <th width="">Menu Item Name</th>
                                  <th className="align-right">
                                    Quantity Required
                                  </th>
                                  <th className="align-right">
                                    Prior Day Carryover
                                  </th>
                                  <th className="align-right">
                                    New Production
                                  </th>
                                  <th className="align-right">
                                    Total Available
                                  </th>
                                  <th className="align-right">Quantity Sold</th>
                                  <th className="align-right">Carry Over</th>
                                </tr>
                              </thead>
                            </table>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </UserInterface>
  );
};
export default Productions;
